/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ask_NameInputs */



/**
* | output |
* | --- |
* | "Let's set up your profile first - it takes a minute. What's your name? Just type it below and send it." |
*
* @param {Onboarding_Ask_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ask_name = /** @type {((inputs?: Onboarding_Ask_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ask_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Richten wir zuerst dein Profil ein - das dauert eine Minute. Wie heißt du? Tipp deinen Namen einfach unten ein und schick ihn ab.")
	return /** @type {LocalizedString} */ ("Let's set up your profile first - it takes a minute. What's your name? Just type it below and send it.")
});